import { Program } from './types';

export const programs: Program[] = [
  {
    title: 'Climate Adaptation Finance Professional Certificate (CAFP)',
    description: 'A comprehensive program jointly developed with Frankfurt School of Finance and Management, MUBS, and ARIN.',
    image: '/images/CAFP-Adaptation-Finance.JPG',
    category: 'Professional Certificate',
    duration: '4 months',
    featured: true,
    link: '/programs/cafp#top'
  }
];